import useTenant from "../../hooks/useTenant";
import { AutoCompleteOption } from "../common/AutoComplete";
import DamageFormService from "../damageFormList/service/DamageFormService";
import DamagePriceService from "../damageListCrud/service/damagePrice.action";
import DamageService from "./service/damage.action";


export const getAllClass = (tenantValue:any): Promise<AutoCompleteOption[]> => {
  return DamageService.get.allClass(tenantValue).then(response => response.map((res:any) => ({ label: `${res} `, value: res })),
  );
}

export const getAllWinityCodes = (tenantValue:any): Promise<AutoCompleteOption[]> => {
  return DamageService.get.allWinityCodes(tenantValue).then(response => response.map((res:any) => ({ label: `${res}`, value: res})),
  )
}
export const getAllPart = (tenantValue:any): Promise<AutoCompleteOption[]> => {
    return DamageService.get.allPart(tenantValue).then(response => response.map((res:any) => ({ label: `${res.label}`, value: `${res.part.id}-${res.position.id}` })),
    )
}
export const getAllSeverity =(tenantValue:any):Promise<AutoCompleteOption[]> =>{
  return DamagePriceService.get.getallSeverity().then(response =>response.map((res:any) =>({label:`${res}`, value:`${res}`})))
}
export const getAllRepository = (tenantValue:any): Promise<AutoCompleteOption[]> => {
  return DamageFormService.list.getRepository(tenantValue).then(response => response.map((res:any) => ({ label: `${res.descr}`, value: `${res.id}` })),
  )
}